import { use, Suspense, useState, useEffect } from "react";
import styles from "./StockMessage.module.scss";
import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";

function StockMessageContent() {
  const dispatch = useProductCardEvent();
  const { onlineStock } = useVariant();
  onlineStock.catch(() => {
    dispatch(productCardEvents.onlineStockDataError);
  });
  const stockData = use(onlineStock);
  const stockMessage = stockData?.stockMessage;

  if (!stockMessage) {
    return null;
  }

  return (
    <p data-component="pcl-StockMessage" className={styles.message}>
      {stockMessage}
    </p>
  );
}

function StockMessageLoading() {
  return (
    <p
      data-component="pcl-StockMessage"
      className={styles["message-loading"]}
    />
  );
}

export function StockMessage() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(function markStockMessageAsMounted() {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <StockMessageLoading />;
  }

  return (
    <Suspense fallback={<StockMessageLoading />}>
      <StockMessageContent />
    </Suspense>
  );
}
